module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }